import DashboardLayout from "../../components/Layout/DashboardLayout";
import AdminApplications from "../../components/Admin/AdminApplications";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const IncompleteDocumentPendingApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Incomplete Document Pending Applications(TIFC)"
        status={[applicationStatusMap?.incompleteDocumentPending.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default IncompleteDocumentPendingApplications;
